import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommandsMobile = _resolveComponent("CommandsMobile")
  const _component_CommandsDesktop = _resolveComponent("CommandsDesktop")

  return (_ctx.$responsive.mobile)
    ? (_openBlock(), _createBlock(_component_CommandsMobile, {
        key: 0,
        disabled: !$options.skills.length && !$options.sources.length,
        skills: $options.skills,
        sources: $options.sources,
        onSkill: _cache[0] || (_cache[0] = $event => (_ctx.$emit('skill', $event))),
        onSource: _cache[1] || (_cache[1] = $event => (_ctx.$emit('source', $event)))
      }, null, 8 /* PROPS */, ["disabled", "skills", "sources"]))
    : (_openBlock(), _createBlock(_component_CommandsDesktop, {
        key: 1,
        disabled: !$options.skills.length && !$options.sources.length,
        skills: $options.skills,
        sources: $options.sources,
        onSkill: _cache[2] || (_cache[2] = $event => (_ctx.$emit('skill', $event))),
        onSource: _cache[3] || (_cache[3] = $event => (_ctx.$emit('source', $event)))
      }, null, 8 /* PROPS */, ["disabled", "skills", "sources"]))
}